<template>
  <div>
    <div id="support">
      <el-row>
        <div id="powered-container">
          <span @click="safetyPage()">
            <img src="../assets/images/powered-safety.svg" class="powered-img" />
          </span>
        </div>
        <div id="support-container">
          <el-button type="success" class="support-btn" @click="dialogInstructivo = true">
            <i class="el-icon-tickets" /> {{ $t("Preguntas Frecuentes") }}
          </el-button>
          <el-button type="danger" class="support-btn" @click="dialogManuales = true">
            <i class="el-icon-tickets" /> {{ $t("Manuales") }}
          </el-button>
          <el-button type="primary" class="support-btn" @click="supportVideoVisible = true">
            <i class="el-icon-caret-right" /> {{ $t("Video Tutorial") }}
          </el-button>
          <el-button type="info" class="support-btn" @click="supportFormVisible = true">
            <i class="el-icon-message" />
            <span class="responsive-float-fix">Escríbenos</span>
          </el-button>
          <el-button type="warning" class="support-btn" @click="supportPhoneVisible = true">
            <i class="el-icon-phone-outline" />
            <span class="responsive-float-fix">Llámanos</span>
          </el-button>
        </div>
      </el-row>

      <!--Dialog teléfono-->
      <el-dialog
        :visible.sync="supportPhoneVisible"
        title="¿Necesitas Ayuda?"
        class="responsive-float-dialog"
        center
      >
        <hr />
        <p class="support-phone-1">
          +56 9 9022 5668
        </p>
        <hr />
        <p class="support-text">
          También puede comunicarse con nosotros escribiendo directamente a
          <b>support@safetyclub.zendesk.com</b>
        </p>
        <p class="support-text">
          <i>Horario atención telefónica: Lunes a Viernes de 9:00 a 18:30</i>
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button type="warning" style="width: 150px" @click="supportPhoneVisible = false"
            >Cancelar</el-button
          >
        </span>
      </el-dialog>

      <!--Dialog correo-->
      <el-dialog
        :visible.sync="supportFormVisible"
        title="¿Necesitas Ayuda?"
        class="responsive-float-dialog"
        center
      >
        <el-form ref="form" :model="form" :rules="rules" status-icon>
          <el-form-item label="Nombre Completo*" prop="nombre">
            <el-input v-model="form.nombre" />
          </el-form-item>
          <el-form-item label="Correo*" prop="correo">
            <el-input v-model="form.correo" />
          </el-form-item>
          <el-form-item type="number" label="Teléfono" prop="telefono">
            <el-input v-model="form.telefono">
              <template slot="prepend">+56</template>
            </el-input>
          </el-form-item>
          <el-form-item label="Tipo de Usuario">
            <br />
            <el-select
              v-model="form.perfil"
              class="w-100"
              prop=""
              placeholder="Seleccione tipo de usuario"
            >
              <el-option
                v-for="(value, key) in bhpProfiles"
                :key="key"
                :label="value"
                :value="key"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Mensaje*" prop="mensaje">
            <el-input v-model="form.mensaje" type="textarea" />
          </el-form-item>
        </el-form>
        <p class="support-text">
          También puede comunicarse con nosotros escribiendo directamente a
          <b>support@safetyclub.zendesk.com</b> o llamando al <br />
          <b>+56 9 9022 5668</b>.
        </p>
        <p class="support-text">
          <i>Horario atención telefónica y chat: Lunes a Viernes de 9:00 a 18:30</i>
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cleanForm">Cancelar</el-button>
          <el-button type="primary" @click="sendMail('form')">Enviar</el-button>
        </span>
      </el-dialog>

      <el-dialog title="Tutorial Inventario de Riesgos" :visible.sync="supportVideoVisible">
        <!-- Video Administrador Plataforma -->
        <div>
          <p class="text-tutorial">
            El siguiente video corresponde a un tutorial para el uso del
            <b><span class="text-bhp">Dashboard General</span></b>
          </p>

          <p></p>

          <div class="">
            <div class="resp-container">
              <iframe
                class="resp-iframe"
                src="https://www.youtube.com/embed/OXzN04DhNAM"
                frameborder="0"
                allow="autoplay; encrypted-media"
                allowfullscreen
              />
            </div>
          </div>
        </div>
        <br /><br />
        <div>
          <p class="text-tutorial">
            El siguiente video corresponde a un tutorial para el uso del
            <b><span class="text-bhp">Reporte mensual para la Gerencia</span></b>
          </p>

          <p></p>

          <div class="">
            <div class="resp-container">
              <iframe
                class="resp-iframe"
                src="https://www.youtube.com/embed/jmKvU7VW1jM"
                frameborder="0"
                allow="autoplay; encrypted-media"
                allowfullscreen
              />
            </div>
          </div>
        </div>
        <br /><br />
        <div>
          <p class="text-tutorial">
            El siguiente video corresponde a un tutorial para el uso del
            <b><span class="text-bhp">Reporte General Personalizado</span></b>
          </p>

          <p></p>

          <div class="">
            <div class="resp-container">
              <iframe
                class="resp-iframe"
                src="https://www.youtube.com/embed/Z_bJVWxe5T8"
                frameborder="0"
                allow="autoplay; encrypted-media"
                allowfullscreen
              />
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button style="width: 150px" type="warning" @click="supportVideoVisible = false">{{
            $t("Cancelar")
          }}</el-button>
        </span>
      </el-dialog>

      <!--Dialog preguntas-->
      <el-dialog
        :visible.sync="dialogInstructivo"
        :title="$t('Preguntas frecuentes Plataforma inventario de riesgos HSE online')"
        width="80%"
        center
        top="30px"
      >
        <pdf src="/files/preguntas.pdf"></pdf>
        <span slot="footer" class="dialog-footer">
          <el-button
            size="large"
            style="width: 150px"
            type="warning"
            @click="dialogInstructivo = false"
            >{{ $t("Cancelar") }}</el-button
          >
        </span>
      </el-dialog>

      <!-- Dialog Manuales -->

      <el-dialog :visible.sync="dialogManuales" :title="$t('¿Necesitas Ayuda?')" width="43%" center>
        <center>
          <a download href="/files/instructivo.pdf">
            <el-button
              style="width: 100%; font-size: 12px"
              plain
              type="primary"
              size="small"
              icon="el-icon-tickets"
            >
              Instructivo y terminología para campos de medio ambiente</el-button
            >
          </a>
          <br /><br />
          <el-button
            style="width: 100%; font-size: 12px"
            plain
            type="primary"
            size="small"
            icon="el-icon-tickets"
            @click="descargarInstructivo('mel')"
            >Descargar Instructivo revisión por tarea (MEL)</el-button
          >
          <br /><br />
          <el-button
            style="width: 100%; font-size: 12px"
            plain
            type="primary"
            size="small"
            icon="el-icon-tickets"
            @click="descargarInstructivo('spence')"
            >Descargar Instructivo revisión por tarea (SPENCE, CERRO COLORADO, BHP)</el-button
          >
          <br /><br />
          <!-- <el-button style="width: 100%; font-size: 12px;" plain type="primary" size="small" icon="el-icon-tickets" @click="descargarManual()">Descargar Manual de
            Usuario</el-button>
          <br><br> -->
          <a download href="/files/boletincorreos.pdf">
            <el-button
              style="width: 100%; font-size: 12px"
              plain
              type="primary"
              size="small"
              icon="el-icon-tickets"
            >
              Descargar Boletín de uso de cuentas institucionales</el-button
            >
          </a>
        </center>

        <span slot="footer" class="dialog-footer">
          <el-button type="warning" style="width: 150px" @click="dialogManuales = false">{{
            $t("Cancelar")
          }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
const SERVICE_EMAIL_URL = "/usuarios/mailing/soporte";
import pdf from "vue-pdf";
import axios from "axios";

export default {
  name: "SupportFooter",
  data() {
    const validarNombre = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("Nombre es obligatorio"));
      }
      callback();
    };
    const validarCorreo = (rule, value, callback) => {
      const re = new RegExp("^[_a-z0-9-]+(.[_a-z0-9-]+)*@[a-z0-9-]+(.[a-z0-9-]+)*(.[a-z]{2,4})$");
      if (value === "") {
        return callback(new Error("Correo es obligatorio"));
      }
      if (!value.match(re)) {
        return callback(new Error("Error formato correo"));
      }
      callback();
    };
    const validarTelefono = (rule, value, callback) => {
      const pattern = new RegExp("^\\d{9}$");
      if (value === "" || !value.match(pattern)) {
        return callback(new Error("Error formato teléfono: 9 números"));
      }
      callback();
    };
    const validarMensaje = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("Mensaje es obligatorio"));
      }
      callback();
    };
    return {
      dialogInstructivo: false,
      dialogManuales: false,
      supportVideoVisible: false,
      supportFormVisible: false,
      supportPhoneVisible: false,
      sendingEmail: false,
      bhpProfiles: {
        hse: "HSE",
        contractor_hse: "HSE Contratista",
        owner: "Dueño de Contrato",
        risk: "Especialista de Riesgo",
        admin: "Administrador de Contrato",
        contractor_coordinator: "Coordinador Contratista",
        coordinator: "Coordinador",
        manager: "Gerente",
        super: "Superintendente",
        general_manager: "Gerente General",
      },
      form: {
        nombre: "",
        correo: "",
        telefono: "",
        perfil: "",
        mensaje: "",
      },
      rules: {
        nombre: [{ validator: validarNombre, trigger: "blur" }],
        correo: [{ validator: validarCorreo, trigger: "blur" }],
        telefono: [{ validator: validarTelefono, trigger: "blur" }],
        mensaje: [{ validator: validarMensaje, trigger: "blur" }],
      },
    };
  },
  watch: {
    showSupportOptions() {
      if (process.browser) {
        if (window.zE) {
          window.zE.show();
        } else {
          // Start of safetyclub Zendesk Widget script
          window.zE ||
            (function (e, t, s) {
              var n =
                (window.zE =
                window.zEmbed =
                  function () {
                    n._.push(arguments);
                  });
              const a = (n.s = e.createElement(t));
              const r = e.getElementsByTagName(t)[0];
              n.set = function (e) {
                n.set._.push(e);
              };
              n._ = [];
              n.set._ = [];
              a.async = true;
              a.setAttribute("charset", "utf-8");
              a.src = `https://static.zdassets.com/ekr/asset_composer.js?key=${s}`;
              n.t = +new Date();
              a.type = "text/javascript";
              r.parentNode.insertBefore(a, r);
            })(document, "script", "cd9487bd-3ef3-4a2c-8bcc-1d563414092d");
        }
      }
    },
  },
  mounted() {
    if (process.browser) {
      // ZendeskChat
      window.zESettings = {
        webWidget: {
          offset: {
            horizontal: "0px",
            vertical: "0px",
          },
          chat: {
            suppress: false,
          },
          talk: {
            suppress: false,
          },
          helpCenter: {
            suppress: false,
          },
          contactForm: {
            suppress: true,
          },
        },
      };
    }
  },
  components: {
    pdf,
  },
  methods: {
    descargarManual() {
      window.location.href =
        "https://gitlab.safetyclub.cl/yonatan.pizarro/manual-bhp/-/raw/master/MAm-HSE-MAN-219%20Manual%20Plataforma%20de%20Inventario%20de%20Riesgos%20HSE%20firmado.pdf?inline=false";
    },
    descargarInstructivo(faena) {
      const fileName =
        faena === "mel"
          ? "Revision_tarea_MEL.pdf"
          : "Instructivo_Revision_por_tarea_Pampa_Norte.pdf";

      const link = document.createElement("a");
      link.href = `/${fileName}`;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    sendMail(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sendingEmail = true;

          const config = {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          };
          axios
            .post(SERVICE_EMAIL_URL, { form: this.form }, config)
            .then((response) => {
              this.sendingEmail = false;
              this.$alert("Correo enviado exitosamente.", "Proceso exitoso", {
                type: "success",
              });
              this.cleanForm();
            })
            .catch((error) => {
              this.sendingEmail = false;
              console.error(error);
              this.$alert("Lo sentimos, ha surgido un error. Intente nuevamente.", "Atención", {
                type: "error",
              });
            });
        } else {
          console.log("formulario no válido");
          return false;
        }
      });
    },
    cleanForm() {
      this.form.nombre = "";
      this.form.correo = "";
      this.form.telefono = "";
      this.form.perfil = "";
      this.form.mensaje = "";

      this.supportFormVisible = false;
    },
    safetyPage() {
      window.open("http://safetyclub.cl", "_blank");
    },
  },
};
</script>

<style scoped>
#support {
  margin-top: 80px;
}

#Embed {
  display: none;
}

#support-container {
  position: fixed;
  bottom: 10px;
  right: 150px;
  z-index: 999;
}

#powered-container {
  position: fixed;
  bottom: 10px;
  left: 20px;
  z-index: 999;
}

[class*=" el-icon-"],
[class^="el-icon-"] {
  font-weight: bold;
}

.el-button {
  letter-spacing: 0.6;
  font-size: 0.9rem;
  font-weight: 600;
  padding: 15px;
}

.support-btn {
  height: 47px;
  border-radius: 999rem;
}

.support-text {
  text-align: center;
}

.support-phone-1 {
  text-align: center;
  font-size: 3em;
}

.support-phone-2 {
  text-align: center;
  font-size: 2em;
}

.w-100 {
  width: 100%;
}

.powered-img {
  height: 30px;
}

@media (max-width: 580px) {
  .responsive-float-fix {
    display: none;
  }

  #powered-container {
    position: absolute;
    bottom: 30px;
    left: 20px;
  }

  .responsive-float-dialog {
    width: 140% !important;
    margin-left: -20%;
  }
}

@media (max-width: 320px) {
  .responsive-float-dialog {
    width: 190% !important;
    margin-left: -45%;
  }
}
</style>
